import List from '@jetbrains/ring-ui/components/list/list'

import type {Branch} from '../../../services/rest'
import type {BranchItem, SelectedBranch} from '../../../types'
import {DEFAULT_NAME, stringifyBranch} from '../../../utils/branchNames'

import styles from './BranchSelect.css'

export const matches = (branch: Branch, selected: Branch): boolean => {
  if (selected.default === true) {
    return branch.default === true
  }

  if (selected.groupFlag === true) {
    return branch.groupFlag === true && branch.internalName === selected.internalName
  }

  return branch.name === selected.name
}
export const createItem = (
  branch: SelectedBranch | null | undefined,
  specialLabel?: string,
): BranchItem | null =>
  branch
    ? {
        label:
          specialLabel ??
          (branch.default === true && branch.name === DEFAULT_NAME
            ? '<Default branch>'
            : branch.name),
        key: stringifyBranch(branch),
        branch,
        className: styles.item,
      }
    : null
export const createSeparator = (description: string): BranchItem => ({
  rgItemType: List.ListProps.Type.SEPARATOR,
  description,
  key: `group_${description}`,
})
export const createGroup = (
  description: string,
  branches: ReadonlyArray<Branch>,
): ReadonlyArray<BranchItem | null | undefined> => [
  branches.length ? createSeparator(description) : null,
  ...branches.map(branch => createItem(branch)),
]
